import { useMemo } from 'react';

/**
 * Un hook personalizado que selecciona una frase aleatoria de una lista
 * cada vez que el componente que lo usa se carga.
 * @param phrases - Un array de strings con las frases para elegir.
 * @returns Una única frase del array.
 */
export const useRandomText = (phrases: string[]): string => {
  // `useMemo` se asegura de que el texto solo se elija una vez cuando el
  // componente se monta, y no en cada re-renderizado.
  // Pero en una recarga de página, se volverá a ejecutar.
  const randomText = useMemo(() => {
    if (!phrases || phrases.length === 0) {
      return '';
    }

    // ANTES: Usábamos la fecha para un índice predecible.
    // const dayIndex = Math.floor(Date.now() / (1000 * 60 * 60 * 24));
    // const randomIndex = dayIndex % phrases.length;

    // AHORA: Usamos Math.random() para un índice totalmente aleatorio en cada carga.
    const randomIndex = Math.floor(Math.random() * phrases.length);

    return phrases[randomIndex];
  }, [phrases]);

  return randomText;
};    